import { PreferredTimeModel } from "./dataStructures";
import { convertTimePickerToServerTime } from "./utilityFunctions";

export function giveFormDataFromPrefTime(
  user_id: string,
  pref_time: PreferredTimeModel
) {
  let form: FormData = new FormData();
  form.append("user_id", user_id);
  form.append("name", pref_time.day_key);
  form.append("start_at", convertTimePickerToServerTime(pref_time.start_time));
  form.append("end_at", convertTimePickerToServerTime(pref_time.end_time));
  return form;
}

export function giveURLSchemeFromPrefTime(
  user_id: string,
  pref_time: PreferredTimeModel
) {
  let params: URLSearchParams = new URLSearchParams();
  if (pref_time.day_id !== undefined) {
    params.append("id", pref_time.day_id);
  }
  params.append("user_id", user_id);
  params.append("name", pref_time.day_key);
  params.append(
    "start_at",
    convertTimePickerToServerTime(pref_time.start_time)
  );
  params.append("end_at", convertTimePickerToServerTime(pref_time.end_time));
  return params;
}

/////// Image Helper Functions ///////
// utils/generateImageName.js
export function generateImageName() {
  const uniqueId = crypto.randomUUID();
  return `profile-${uniqueId}.png`;
}

export function dataURLToBlob(dataURL: string): Blob {
  const [header, base64] = dataURL.split(",");
  const mimeMatch = header.match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
  const binary = atob(base64);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new Blob([array], { type: mime });
}

/*
const handleUpload = async (file) => {
  const formData = new FormData();
  formData.append("profileImage", file);

  try {
    const response = await fetch("https://yourserver.com/upload", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    console.log("Uploaded file URL:", data.url);
  } catch (error) {
    console.error("Upload failed:", error);
  }
};
*/
